import BaseCommand from "../BaseCommand";

export class CopyCreationDateToAllBookingItems extends BaseCommand {
  CommandName = "CopyCreationDateToAllBookingItems";
  Command: {
    CreationDate: string;
  };
  constructor(sessionId: string, operationId: string, creationDate: string) {
    super(sessionId, operationId);
    this.Command = { CreationDate: creationDate };
  }
}
